<template>
  <!--This is for rows without subsections-->
	<v-container v-if="answers && (!row.subs || row.subs.length == 0)" grid-list-md>
		<v-flex xs12>
      <value-validation-message :qId="Number(qId)" :hasExp="hasExp" :subSectionIds="[ row.header, answers.answerCode, row.label ]" :answerIds="this.getAnswerIds(this.row)" :rowIndex="this.$vnode.key">
      </value-validation-message>
    </v-flex>
    <!-- hello no subs key: {{this.$vnode.key}} -->
    <!-- myRows: {{this.myRows}}<br /><br /> -->
    <!-- qColumns: {{this.qColumns.length}}  -->
		<div style="width:100%" >
    	<v-layout class="answers-row">
      <v-flex class="left-label" xs3>
        <header-cell
          v-if="row.isFakeSub != undefined"
          :isSub="true"
          :header="row.header"
          :label="row.label"
					:state="row.state"
          :question="row.question"
          :question-id="row.questionId"
          :answer-id="row.answerId"
          :cell-id="row.cellId"
          :help="row.help"
        ></header-cell>
        <header-cell
          v-else
          :isSub="false"
          :header="row.header"
          :label="row.label"
					:state="row.state"
          :question="row.question"
          :question-id="row.questionId"
          :answer-id="row.answerId"
          :cell-id="row.cellId"
          :help="row.help"
          :hasDelete="isDynamic"
          v-on:delete="deleteRow"
        ></header-cell>
      </v-flex>
      <v-flex class="tb-width" v-for="(answer, index) in row.answers" :key="index" xs1>
        <!--Cells for user input-->
      <value-cell
          v-if="((index != row.answers.length - 1 || displayLayout == displayLayouts.J || displayLayout == displayLayouts.K || displayLayout == displayLayouts.I || displayLayout == displayLayouts.M)
								&& !((displayLayout == displayLayouts.G && rowIndex == myRows.length - 2) || (!isDynamic && rowIndex == myRows.length - 1) || row.label === 'Total' || row.answers[index].answerId == 'tot')
								)"
          :has-outline="hasOutline"
          :is-read-only="readOnly"
          :index="parseInt(index)"
          :name="answer.answerId"
          prefix="$"
          :id="qId"
          :value="answers[answer.answerId]"
          v-on:update="onUpdateRowAnswers"
					:rowLabel = "row.label"
        ></value-cell>
        <!--Cells for row totals-->
        <computation-cell
					v-else-if="displayLayout != displayLayouts.M && (displayLayout != displayLayouts.J && (index == row.answers.length - 1 && row.label != 'Total')
											&& (displayLayout != displayLayouts.K) || (row.answers[index].answerId == 'tot' && row.label != 'Total'))"
          :id="qId"
          :name="answer.answerId"
          :index="parseInt(index)"
          :value="getRowTotal(row.answers.length-1,answers,rowIndex, null, parseInt(index))"
          v-on:update="onUpdateRowAnswers"
        ></computation-cell>
        <!--Cells for column totals-->
       <computation-cell
					v-else-if= "(displayLayout == displayLayouts.G && rowIndex == myRows.length - 2) || rowIndex == myRows.length - 1 || row.label === 'Total'"
          :id="qId"
          :name="answer.answerId"
          :index="parseInt(index)"
          :value="getColumnTotal(myRows.length-1,answers,index, rowIndex, answer.answerId)"
          v-on:update="onUpdateRowAnswers"
					v-on:update:disable="$emit('update:disable', true)"
					:disabled="isNA"
				></computation-cell>
      </v-flex>
    	</v-layout>
		</div>
  </v-container>

  <!--This is for rows with subsections-->
  <v-container v-else grid-list-md>
    <v-layout>
      <v-flex class="left-label" xs3>
        <header-cell
          :isSub="false"
          :header="row.header"
          :label="row.label"
          :question="row.question"
          :question-id="row.questionId"
          :answer-id="row.answerId"
          :cell-id="row.cellId"
        ></header-cell>
      </v-flex>
    </v-layout>
		<div v-for="(row1, index1) in row.subs" :key="index1">
			<v-flex xs12>
				<value-validation-message :qId="Number(qId)" :hasExp="hasExp" :subSectionIds="[row.header, row1.header, answers.answerCode, row.label, row1.label]" :answerIds="getAnswerIds(row1)" :rowIndex="index1"></value-validation-message>
			</v-flex>
			<v-layout class="answers-row">
				<v-flex class="left-label" xs3>
					<header-cell
						:isSub="true"
						:header="row1.header"
						:label="row1.label"
						:question="row1.question"
						:question-id="row1.questionId"
						:answer-id="row1.answerId"
						:cell-id="row1.cellId"
						:class="'marginleft'"
					></header-cell>
				</v-flex>
				<v-flex class="tb-width" v-for="(answer, index) in row1.answers" :key="index" xs1>
					<value-cell
						v-if="(displayLayout == displayLayouts.J)
									|| ((index != row1.answers.length - 1 || displayLayout == displayLayouts.K) && (index1 != row.subs.length-1 || row.subs[0].isFakeSub != undefined))"
						:has-outline="hasOutline"
						:is-read-only="readOnly"
						:index="parseInt(index)"
						:name="answer.answerId"
						:subHeader="row1.label"
            :id="qId"
						prefix="$"
						:value="answers[answer.answerId]"
						v-on:update="onUpdateRowAnswers"
					></value-cell>
					<computation-cell
						v-else-if="index == row1.answers.length - 1 && displayLayout != displayLayouts.K"
						:id="qId"
						:name="answer.answerId"
						:index="parseInt(index)"
						:subHeader="row1.label"
						:value="getRowTotal(row1.answers.length-1,answers,rowIndex, index1)"
						v-on:update="onUpdateRowAnswers"
					></computation-cell>
					<computation-cell
						v-if="(index != row1.answers.length - 1 && displayLayout != displayLayouts.J || (index1 == row.subs.length - 1 && displayLayout == displayLayouts.K)) && index1 == row.subs.length - 1 && row.subs[0].isFakeSub == undefined"
						:id="qId"
						:name="answer.answerId"
						:index="parseInt(index)"
						:subHeader="row1.label"
						:value="getColumnTotal(row.subs.length-1,answers,rowIndex, index1, answer.answerId)"
						v-on:update="onUpdateRowAnswers"
					></computation-cell>
				</v-flex>
			</v-layout>
		</div>
  </v-container>
</template>

<script>
import { utilityService } from '../../services/utilityService';
import { CONSTANTS } from './../../common/constants';
export default {
  name: 'AnswersRow',
  props: {
    row: Object,
    qId: String,
    answers: Object,
    myRows: Array,
    qColumns: Array,
    fullAnswer: Object,
    fullAnswerArray: Array,
    isDynamic: Boolean,
    displayLayout: Number,
		displayLayouts: Object,
		hasExp: Boolean,
		isNA: Boolean
  },
  data: () => ({
    theValue: undefined,
    hasOutline: false,
    readOnly: false,
    rowIndex: null,
    qColumnsLength: 0
  }),
  mounted () {
    console.log("this.value", this.value);
    this.theValue = this.value;
  },
  computed: {
    sectionAnswers: function () {
      return this.$store.getters['answersArray'][this.qId];
		}
  },
  created () {
    const me = this;
    me.rowIndex = this.$vnode.key;
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'saveAnswer' && me.id === mutation.payload.id) {
        let total = 0;
        const val = mutation.payload.value;
        if (val && me.fields && me.fields.length > 0) {
          me.fields.forEach(field => {
            let fieldVal = val[field];
            if (typeof val[field] === 'string') {
              fieldVal = utilityService.convertStringToNum(fieldVal);
            }
            total += fieldVal;
          });
          this.theValue = utilityService.addCurrencyCommas(total.toString());
        }
      }
    });
  },
  methods: {
    onUpdateRowAnswers: function (evt) {
      if (this.displayLayout === this.displayLayouts.D)
      {
        this.$emit('update', {
          value: evt.value,
          questionId: this.row.header,
          answerId: evt.answerId
        });
      }
      else if (this.displayLayout == this.displayLayouts.A || this.displayLayout == this.displayLayouts.C || this.displayLayout == this.displayLayouts.I || this.displayLayout == this.displayLayouts.N)
      {
        debugger;
        var identifierName;
				if (this.displayLayout == this.displayLayouts.I)
        {
					if (this.row.label == CONSTANTS.LAYOUT_I_STATIC_ROW_NAMES.TOTAL)
          {
						identifierName = this.answers.orgCod;
					}
          else
          {
						identifierName = this.row.header;
					}
				} else {
          debugger;
					var idNames = Object.keys(this.answers);
					var found = false;
					var idName = '';

					for (let i = 1; i < idNames.length && !found; i++) {
						if (idNames[i].toLowerCase().includes('id')) {
							idName = idNames[i];
							found = true;
						}
					}
					identifierName = this.answers[idName];
        }

        let approxIndex = 0;

        this.$emit('update', {
          value: evt.value,
          questionEntryId: identifierName,
          answerId: evt.answerId,
          approxIndex: approxIndex
        });
      } else {
        this.$emit('update', evt);
      }
		},

    getColumnTotal: function (numRows, answer, index, subIndex, name) {
      var i;
      var sum = 0;

      // This calculates the last row which is the sum of the totals of each subsection
     if (this.displayLayout == this.displayLayouts.D && this.rowIndex + 1 == this.myRows.length)
      {
        // Size - 1 so that we do not add the total to itself
        for (i = 0; i < this.myRows.length - 1; i++) {
          var section = this.fullAnswer[this.myRows[i].header];
          // Sections with subsections already have a total, using that total instead of looping through each value
          if (this.myRows[i].subs) {
            var subsLastIndx = this.myRows[i].subs.length - 1;
            sum += section[this.myRows[i].subs[subsLastIndx].answers[index].answerId];
          } else {
            sum += section[this.myRows[i].answers[index].answerId];
          }
        }
        return sum;
      }

      if (this.displayLayout == this.displayLayouts.G && this.rowIndex + 2 == this.myRows.length)
      {
        var columnidx = this.myRows[subIndex].answers.findIndex(x => x.answerId === name);
        for (i = 2; i < numRows - 1; i++) {
          sum += answer[this.myRows[i].answers[columnidx].answerId];
        }
        return sum;
      }
      else if (this.displayLayout == this.displayLayouts.G && this.rowIndex + 1 == this.myRows.length)
      {
        columnidx = this.myRows[subIndex].answers.findIndex(
          x => x.answerId === name
        );
        for (i = 0; i < numRows - 1; i++) {
          sum += answer[this.myRows[i].answers[columnidx].answerId];
        }
        return sum;
      }

          if (this.row.subs)
          {
            columnidx = this.row.subs[subIndex].answers.findIndex(x => x.answerId === name);
            for (i = 0; i < numRows; i++)
            {
              sum += answer[this.row.subs[i].answers[columnidx].answerId];
            }
          }
          else
          {
            columnidx = this.myRows[subIndex].answers.findIndex(x => x.answerId === name);
            if (this.displayLayout == this.displayLayouts.I)
            {
              for (i = 0; i < this.sectionAnswers.length; i++)
              {
                if (this.displayLayout == this.displayLayouts.I && i === 0)
                {
                  if (this.sectionAnswers[i][name] == Number.MIN_SAFE_INTEGER)
                  {
                    return Number.MIN_SAFE_INTEGER;
                  }
                  else
                  {
                    continue;
                  }
                }
                sum += this.sectionAnswers[i][name];
              }
            }
            else
            {
              for (i = 0; i < numRows; i++)
              {
                if (i==0 && this.displayLayout == this.displayLayouts.J)
                {
                   //nothing..
                }
                else
                {
                  if (this.displayLayout == this.displayLayouts.A || this.displayLayout == this.displayLayouts.C || this.displayLayout == this.displayLayouts.N)
                  {
                    sum += this.sectionAnswers[i][name];
                  }
                  else
                  {
                    if (this.myRows[i].subs) {
                      var subsLastIndx = this.myRows[i].subs.length - 1;
                      sum += answer[this.myRows[i].subs[subsLastIndx].answers[columnidx].answerId]
                        ? answer[this.myRows[i].subs[subsLastIndx].answers[columnidx].answerId] : 0;
                    } else if (this.displayLayout === this.displayLayouts.M) {
									    if (i !== 3) {
											sum += answer[this.myRows[i].answers[columnidx].answerId]
                        ? answer[this.myRows[i].answers[columnidx].answerId] : 0;
											}
                    } else {
									    sum += answer[this.myRows[i].answers[columnidx].answerId]
                        ? answer[this.myRows[i].answers[columnidx].answerId] : 0;
                    }
                  }
                }
              }
            }
          }
      return sum;
    },

    getRowTotal: function (numColumns, answer, index, subIndex, totIndex) {
      var i;
			var sum = 0;
			debugger;
			if (this.displayLayout == this.displayLayouts.I) {
				var arr = this.row.answers;

				for (i = 0; i < totIndex; i++) {
          sum += answer[arr[i].answerId];
				}

				return sum;
			}

      if (subIndex == null) {
        var arr = this.row.answers;
        for (i = 0; i < arr.length - 1; i++) {
          sum += answer[arr[i].answerId];
        }
      }
      else {
        arr = this.row.subs[subIndex].answers;
        for (i = 0; i < arr.length - 1; i++) {
          sum += answer[arr[i].answerId];
        }
      }

      return sum;
    },
		deleteRow: function () {
			var label;

      if (this.displayLayout == this.displayLayouts.I) {
				label = this.row.header;
			}

      this.$emit('delete', {
        rowName: label
      });
		},
		/**
		 * Gets an array of the answer id values in the answers property. Used by the value validation message component.
		 * @return An array of strings. If answers is null returns an empty array.
		 */
		getAnswerIds: function (row) {
      debugger;

			let answerIds = [];
			if (row.answers) {
				answerIds = row.answers.map(function (item) {
					return item.answerId;
				});
			}
      console.log("answerIDs" + answerIds);
			return answerIds;
		}
  }
};
</script>

<style scoped>
.row-header {
  font-weight: bold;
  color: #13314f;
}
.marginleft {
  margin-left: 0%;
}
.tb-width {
  min-width: 150px;
}
.left-label {
   margin-top: 17px;
   min-width: 450px;
}

/* hover effect on answer rows.  TODO: not show hover effect on rows that are all totals */
div.layout.answers-row:hover {
  border-radius: 5px;
	/*background-color: #848FA2;*/
}

</style>
